export default "__VITE_ASSET__CZqpK_rK__"